import React from 'react'
import {
    InputOTP as OTPInput,
    InputOTPGroup,
    InputOTPSlot,
} from "./primitive"


type Props = {
    value: string
    onChange: (value: string) => void
    maxLength: number
    testId?: string
}

function InputOTP({ value, onChange, maxLength, testId }: Props) {


    return (
        <div className="space-y-2" data-testid={testId}>
            <OTPInput
                maxLength={maxLength}
                value={value}
                onChange={onChange}
            >
                <InputOTPGroup>
                    {/* AWOPS-3496 — the slot index IS the semantic position of the digit in the
                        code, so unlike a list-row index it is a stable identity, not a proxy. */}
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                        <InputOTPSlot
                            key={index}
                            index={index}
                            data-testid={testId ? `${testId}-slot-${index}` : undefined}
                            className='size-16 !text-2xl font-bold bg-canvas'
                        />
                    ))}
                </InputOTPGroup>
            </OTPInput>
        </div>
    )
}


export default InputOTP